/* TINOR email pop-up: scratch the rusty pan to reveal a discount, then sign up via Shopify's customer form. */
(function () {
  var STORE_KEY = 'tinor:email-popup';
  var EMAIL_KEY = 'tinor:email-popup-email';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (_) { return null; }
  }
  function writeStore(data) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(data)); } catch (_) {}
  }
  function session(key, value) {
    try {
      if (value === undefined) return sessionStorage.getItem(key);
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, value);
    } catch (_) {}
    return null;
  }

  function rng(seed) {
    var s = seed;
    return function () { return (s = (s * 16807) % 2147483647) / 2147483647; };
  }

  /* Rusty pan photo (section setting), loaded once per canvas. */
  function rustImage(el, onReady) {
    var src = el.dataset.rustSrc;
    if (!src) return null;
    if (!el.__rust) {
      var img = new Image();
      el.__rustCbs = [];
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = img.onerror = function () {
        el.__rustDone = true;
        el.__rustCbs.splice(0).forEach(function (cb) { cb(); });
      };
      img.src = src.indexOf('//') === 0 ? window.location.protocol + src : src;
      el.__rust = img;
    }
    if (el.__rust.complete && el.__rust.naturalWidth) return el.__rust;
    if (onReady) { el.__rustDone ? onReady() : el.__rustCbs.push(onReady); }
    return null;
  }

  /* Load both pan photos (rusty canvas image + clean <img>) and resolve once
     they're decoded, so the pan never appears half-loaded. */
  function loadPhotos(root, canvas) {
    if (root.__photos) return root.__photos;
    var clean = root.querySelector('.ep__pan-photo');
    var rust = new Promise(function (res) {
      if (!canvas || !canvas.dataset.rustSrc) return res();
      if (rustImage(canvas, res)) res();
    });
    var cleanReady = new Promise(function (res) {
      if (!clean) return res();
      clean.loading = 'eager';
      if (clean.complete && clean.naturalWidth) return res();
      clean.addEventListener('load', res, { once: true });
      clean.addEventListener('error', res, { once: true });
    }).then(function () { return clean && clean.decode ? clean.decode().catch(function () {}) : null; });
    root.__photos = Promise.all([rust, cleanReady]);
    return root.__photos;
  }

  /* Sample points that are part of the pan (opaque in the rusty photo), so
     transparent background never counts as "scratched". */
  var STEP = 6;
  function buildMask(el) {
    try {
      var d = el.getContext('2d').getImageData(0, 0, el.width, el.height).data;
      var pts = [];
      for (var y = 0; y < el.height; y += STEP) {
        for (var x = 0; x < el.width; x += STEP) {
          var i = (y * el.width + x) * 4 + 3;
          if (d[i] > 200) pts.push(i);
        }
      }
      return pts.length ? pts : null;
    } catch (_) { return null; }
  }

  /* Paint the rusty pan surface onto the canvas: the photo if one is set
     and loaded, otherwise the drawn rust. */
  function paint(el, onPhotoReady) {
    var size = el.clientWidth || 300;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    el.width = size * dpr;
    el.height = size * dpr;
    var c = el.getContext('2d');
    c.setTransform(dpr, 0, 0, dpr, 0, 0);
    c.globalCompositeOperation = 'source-over';
    var r = size / 2, rand = rng(7), i, g;
    c.save();
    c.beginPath(); c.arc(r, r, r, 0, Math.PI * 2); c.clip();
    var photo = rustImage(el, onPhotoReady);
    if (photo) {
      // Photo mode: draw the whole image (object-fit: contain, no circle) so it
      // lines up exactly with the clean pan photo underneath.
      c.restore();
      c.save();
      var s = Math.min(size / photo.naturalWidth, size / photo.naturalHeight);
      var w = photo.naturalWidth * s, h = photo.naturalHeight * s;
      c.clearRect(0, 0, size, size);
      c.drawImage(photo, (size - w) / 2, (size - h) / 2, w, h);
      c.restore();
      el.__mask = buildMask(el);
      return size;
    }
    el.__mask = null;
    if (el.dataset.rustSrc && !el.__allowFallback) {
      // Photo still loading: leave the canvas empty (the pan is hidden meanwhile).
      c.restore();
      c.clearRect(0, 0, size, size);
      return size;
    }
    g = c.createRadialGradient(r * 0.8, r * 0.7, 6, r, r, r);
    g.addColorStop(0, '#7d4a28'); g.addColorStop(0.55, '#57311c'); g.addColorStop(1, '#2a170d');
    c.fillStyle = g; c.fillRect(0, 0, size, size);
    var pal = ['#9c5426', '#b8642e', '#7a3f1d', '#d17f3e', '#4a2a17', '#2b1a10', '#c2703a', '#5e3b26'];
    for (i = 0; i < 70; i++) {
      var a = rand() * Math.PI * 2, d = Math.sqrt(rand()) * r, x = r + Math.cos(a) * d, y = r + Math.sin(a) * d;
      c.globalAlpha = 0.18 + rand() * 0.45; c.fillStyle = pal[(rand() * pal.length) | 0];
      c.beginPath(); c.arc(x, y, 4 + rand() * size * 0.09, 0, Math.PI * 2); c.fill();
    }
    for (i = 0; i < 1400; i++) {
      c.globalAlpha = 0.3 + rand() * 0.6; c.fillStyle = pal[(rand() * pal.length) | 0];
      c.fillRect(rand() * size, rand() * size, 0.6 + rand() * 2.2, 0.6 + rand() * 2.2);
    }
    c.globalAlpha = 0.5;
    g = c.createRadialGradient(r * 1.15, r * 1.1, 2, r * 1.15, r * 1.1, r * 0.45);
    g.addColorStop(0, 'rgba(15,10,6,.85)'); g.addColorStop(1, 'rgba(15,10,6,0)');
    c.fillStyle = g; c.fillRect(0, 0, size, size);
    c.globalAlpha = 1; c.lineCap = 'round';
    for (i = 0; i < 46; i++) {
      var rr = r * (0.2 + rand() * 0.72), a0 = rand() * Math.PI * 2;
      c.strokeStyle = 'rgba(235,200,165,' + (0.06 + rand() * 0.12) + ')';
      c.lineWidth = 0.5 + rand() * 0.9;
      c.beginPath(); c.arc(r, r, rr, a0, a0 + 0.3 + rand() * 1.4); c.stroke();
    }
    c.lineWidth = size * 0.055; c.strokeStyle = '#2c1a10';
    c.beginPath(); c.arc(r, r, r - c.lineWidth / 2, 0, Math.PI * 2); c.stroke();
    c.lineWidth = 1.5; c.strokeStyle = 'rgba(255,190,140,.18)';
    c.beginPath(); c.arc(r, r, r - size * 0.058, 0, Math.PI * 2); c.stroke();
    c.restore();
    return size;
  }

  function init(root) {
    if (!root || root.__epInit) return;
    root.__epInit = true;

    var sectionId = root.dataset.sectionId;
    var canvas = root.querySelector('[data-ep-canvas]');
    var panel = root.querySelector('.ep__panel');
    var form = document.getElementById(root.dataset.formId);
    var emailInput = root.querySelector('[data-ep-email]');
    var errorEl = root.querySelector('[data-ep-error]');
    var submitBtn = root.querySelector('[data-ep-submit]');
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    /* ---- Gift button that reopens the pop-up ---- */
    var launcher = root.parentElement && root.parentElement.querySelector('[data-ep-launcher]');
    var launcherAllowed = !!launcher && !(launcher.dataset.mobile !== 'true' && window.matchMedia('(max-width: 749px)').matches);
    var launcherTimer = null;
    function setLauncher(on, wait) {
      if (!launcherAllowed) return;
      clearTimeout(launcherTimer);
      if (!on) { launcher.classList.remove('is-visible'); return; }
      launcherTimer = setTimeout(function () {
        launcher.hidden = false;
        requestAnimationFrame(function () { launcher.classList.add('is-visible'); });
      }, wait || 0);
    }
    var state = { open: false, started: false, revealed: false, drawing: false, last: null, n: 0, size: 0 };
    var lastFocus = null;
    var timer = null; // eslint-disable-line no-unused-vars

    function showStep(name) {
      root.querySelectorAll('[data-ep-step]').forEach(function (s) { s.hidden = s.dataset.epStep !== name; });
    }

    function reset() {
      state.started = false; state.revealed = false; state.drawing = false; state.last = null; state.n = 0;
      root.classList.remove('is-started', 'is-revealed');
      showStep('scratch');
      if (errorEl) errorEl.hidden = true;
    }

    function open(opts) {
      if (state.open) return;
      state.open = true;
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      setLauncher(false);
      document.body.classList.add('no-scroll');
      var pan = root.querySelector('.ep__pan--photo');
      if (pan && !state.revealed) {
        pan.classList.add('is-loading');
        var shown = false;
        var showPan = function (fallback) {
          if (shown) return;
          shown = true;
          if (fallback && canvas) canvas.__allowFallback = true;
          if (!state.revealed && canvas) state.size = paint(canvas, repaintPhoto);
          requestAnimationFrame(function () { pan.classList.remove('is-loading'); });
        };
        loadPhotos(root, canvas).then(function () { showPan(false); });
        setTimeout(function () { showPan(true); }, 5000);
      }
      requestAnimationFrame(function () {
        if (!pan && !state.revealed && canvas) state.size = paint(canvas, repaintPhoto);
        panel && panel.focus({ preventScroll: true });
      });
      document.addEventListener('keydown', onKey);
    }

    function close(remember) {
      if (!state.open) return;
      state.open = false;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
      document.removeEventListener('keydown', onKey);
      if (remember !== false && !designMode) {
        var data = readStore() || {};
        data.dismissed = Date.now();
        writeStore(data);
      }
      lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
      // Once the email has been submitted the gift button is no longer needed.
      var st = readStore();
      if (!(st && st.claimed)) setLauncher(true, 450);
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(
        panel.querySelectorAll('button, [href], input:not([type=hidden])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ---- Scratching ---- */
    // The rusty photo finished loading: swap it in if nobody has scratched yet.
    function repaintPhoto() {
      if (state.open && !state.started && !state.revealed) state.size = paint(canvas);
    }
    // Switch steps with the panel height animating instead of jumping.
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function swapStep(name) {
      var from = panel ? panel.getBoundingClientRect().height : 0;
      showStep(name);
      var step = root.querySelector('[data-ep-step="' + name + '"]');
      if (reduced.matches || !panel || !panel.animate) return;
      var to = panel.getBoundingClientRect().height;
      if (Math.abs(to - from) > 1) {
        panel.animate({ height: [from + 'px', to + 'px'] }, { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
      if (step) step.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: 80, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
    }
    // Only move focus to the email field with a mouse/trackpad: on phones it
    // opens the keyboard mid-animation and shoves the sheet around.
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    function reveal() {
      if (state.revealed) return;
      state.revealed = true; state.started = true; state.drawing = false;
      root.classList.add('is-started', 'is-revealed');
      swapStep('email');
      if (finePointer.matches) setTimeout(function () { emailInput && emailInput.focus({ preventScroll: true }); }, 450);
    }
    function point(e) {
      var b = canvas.getBoundingClientRect();
      var scale = canvas.clientWidth / b.width;
      return [(e.clientX - b.left) * scale, (e.clientY - b.top) * scale];
    }
    function scratchTo(p) {
      var c = canvas.getContext('2d');
      c.globalCompositeOperation = 'destination-out';
      c.lineCap = 'round'; c.lineJoin = 'round';
      c.lineWidth = canvas.clientWidth * 0.17;
      var a = state.last || p;
      c.beginPath(); c.moveTo(a[0], a[1]); c.lineTo(p[0] + 0.01, p[1]); c.stroke();
      state.last = p;
      if (++state.n % 6 === 0) check();
    }
    function check() {
      var w = canvas.width; if (!w) return;
      var d;
      // A cross-origin photo can block pixel reads; fall back to counting strokes.
      try { d = canvas.getContext('2d').getImageData(0, 0, w, canvas.height).data; } catch (_) { if (state.n > 90) reveal(); return; }
      var clear = 0, tot = 0, r = w / 2, step = 6;
      if (canvas.__mask) {
        // Photo mode: only the pan's own pixels count.
        var m = canvas.__mask;
        for (var k = 0; k < m.length; k++) { if (d[m[k]] < 100) clear++; }
        if (clear / m.length > 0.5) reveal();
        return;
      }
      for (var y = 0; y < w; y += step) {
        for (var x = 0; x < w; x += step) {
          if ((x - r) * (x - r) + (y - r) * (y - r) > r * r) continue;
          tot++;
          if (d[(y * w + x) * 4 + 3] < 100) clear++;
        }
      }
      if (tot && clear / tot > 0.5) reveal();
    }
    if (canvas) {
      canvas.addEventListener('pointerdown', function (e) {
        if (state.revealed) return;
        try { canvas.setPointerCapture(e.pointerId); } catch (_) {}
        state.drawing = true; state.last = null;
        if (!state.started) { state.started = true; root.classList.add('is-started'); }
        scratchTo(point(e));
      });
      canvas.addEventListener('pointermove', function (e) {
        if (state.drawing && !state.revealed) scratchTo(point(e));
      });
      var stop = function () { if (!state.drawing) return; state.drawing = false; state.last = null; check(); };
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      // Repaint if the pan changes size (desktop <-> mobile) before it was scratched.
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          if (state.open && !state.started && !state.revealed && canvas.clientWidth && canvas.clientWidth !== state.size) state.size = paint(canvas, repaintPhoto);
        }).observe(canvas);
      }
    }

    /* ---- Email step ---- */
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || errorEl.dataset.default;
      errorEl.hidden = false;
      emailInput && emailInput.setAttribute('aria-invalid', 'true');
    }
    function showDone(email) {
      var text = root.querySelector('[data-ep-done-text]');
      if (text) {
        var tpl = text.dataset.template || '';
        text.textContent = email ? tpl.replace('[email]', email) : tpl.replace(/\s*\S*\s*\[email\]/, '');
      }
      root.classList.add('is-started', 'is-revealed');
      state.revealed = true;
      swapStep('done');
      writeStore({ claimed: Date.now(), dismissed: Date.now() });
    }

    if (emailInput) {
      emailInput.addEventListener('input', function () {
        if (errorEl) errorEl.hidden = true;
        emailInput.removeAttribute('aria-invalid');
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailInput.value || '').trim();
        if (!EMAIL_RE.test(email)) { showError(); emailInput.focus(); return; }
        if (designMode) { showDone(email); return; }
        submitBtn && submitBtn.classList.add('is-loading');
        session(EMAIL_KEY, email);

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' },
          credentials: 'same-origin'
        })
          .then(function (res) {
            // Shopify may ask for a bot challenge: fall back to a normal post.
            if (/\/challenge/.test(res.url)) { form.submit(); return null; }
            return res.text().then(function (html) { return { res: res, html: html }; });
          })
          .then(function (out) {
            if (!out) return;
            submitBtn && submitBtn.classList.remove('is-loading');
            var doc = new DOMParser().parseFromString(out.html, 'text/html');
            var scope = doc.getElementById(form.id) || doc;
            var serverError = scope.querySelector('[data-ep-server-error]') || (scope !== doc && scope.querySelector('.errors'));
            var success = /customer_posted=true/.test(out.res.url) || !!scope.querySelector('[data-ep-posted]');
            if (serverError && !success) { showError(serverError.textContent.trim()); return; }
            if (!out.res.ok && !success) { showError(); return; }
            session(EMAIL_KEY, null);
            showDone(email);
          })
          .catch(function () {
            submitBtn && submitBtn.classList.remove('is-loading');
            // Network problem: let the browser post the form normally.
            form.submit();
          });
      });
    }

    /* ---- Buttons ---- */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ep-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('[data-ep-reveal]')) { reveal(); return; }
      var copy = e.target.closest('[data-ep-copy]');
      if (copy) {
        var label = copy.dataset.label || copy.textContent;
        copy.dataset.label = label;
        try { navigator.clipboard.writeText(root.dataset.code).catch(function () {}); } catch (_) {}
        copy.textContent = copy.dataset.copied || label;
        setTimeout(function () { copy.textContent = label; }, 2000);
      }
    });

    if (launcher) {
      ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) {
        launcher.addEventListener(ev, function () { if (root.querySelector('.ep__pan--photo')) loadPhotos(root, canvas); }, { once: true, passive: true });
      });
      launcher.addEventListener('click', function () {
        var st = readStore();
        if (st && st.claimed) {
          // Already claimed: show the code again instead of the scratch game.
          showDone(session(EMAIL_KEY) || '');
        } else {
          reset();
        }
        open();
      });
    }

    /* ---- When to show ---- */
    // Returning from a non-AJAX post (bot challenge / fallback): show the code straight away.
    var posted = root.querySelector('[data-ep-posted]') && location.hash === '#' + root.dataset.formId;
    if (posted && !designMode) {
      showDone(session(EMAIL_KEY));
      session(EMAIL_KEY, null);
      open();
      return root;
    }

    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (!document.body.contains(root)) return;
        if (e.detail && e.detail.sectionId === sectionId) { reset(); open(); }
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (!document.body.contains(root)) return;
        if (e.detail && e.detail.sectionId === sectionId) close(false);
      });
      document.addEventListener('shopify:section:unload', function (e) {
        if (e.detail && e.detail.sectionId === sectionId) close(false);
      });
      root.__epOpen = function () { reset(); open(); };
      return root;
    }

    if (root.dataset.enabled !== 'true' || root.dataset.subscribed === 'true') return root;
    if (root.dataset.mobile !== 'true' && window.matchMedia('(max-width: 749px)').matches) return root;
    var stored = readStore();
    var days = parseInt(root.dataset.days, 10) || 0;
    if (stored && stored.claimed) return root;
    if (stored && stored.dismissed && days > 0 && Date.now() - stored.dismissed < days * 86400000) { setLauncher(true, 1200); return root; }

    var delay = Math.max(0, parseFloat(root.dataset.delay) || 0) * 1000;
    // Start fetching the pan photos a little before the pop-up appears.
    if (root.querySelector('.ep__pan--photo')) setTimeout(function () { loadPhotos(root, canvas); }, Math.max(0, delay - 3000));
    function show() {
      // Don't interrupt if another drawer/modal is open; try again shortly.
      if (document.querySelector('.drawer.is-open, .modal.is-open:not([data-email-popup]), .search-drop.is-open, .mega.is-open')) {
        timer = setTimeout(show, 4000);
        return;
      }
      open();
    }
    timer = setTimeout(show, delay);
    return root;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-email-popup]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-email-popup]');
    if (!root) return;
    init(root);
    // A freshly re-rendered section in the editor is the selected one: show it.
    if (root.__epOpen) root.__epOpen();
  });
})();
